// Menu를 사용하지 않는 이유는 차후에 메뉴 우측에 카운트를 표시하는 기능을 구현해야함
import React from 'react';
import _ from 'underscore';
import { Button, Space, Typography } from 'antd';
// import { StarOutlined } from '@ant-design/icons';
//----------------------------------------------------------------------------------------------------
const { Text, Link } = Typography;
//----------------------------------------------------------------------------------------------------

/**
 * Tabs Menu
 * @author
 * */
const TabsMenu = (props) => {
  const { items, checkedIdx, navigate, width, height, setComponent } = props;

  const [checked, setChecked] = React.useState(checkedIdx || 1);

  return (
    <div style={{ display: 'flex', flexDirectin: 'row' }}>
      {items &&
        _.isArray(items) &&
        items.map((item, idx) => {
          const keyIndex = idx + 1;
          //----------------------------------------------------------------------------------------------------
          return (
            <Button
              type="text"
              key={keyIndex}
              // type="default"
              icon={item.icon(keyIndex == checked)}
              onClick={(e) => {
                setChecked(keyIndex);
                setComponent(item.component);
                // item.onClick({ navigate, path: item.path });
              }}
              style={{
                display: 'flex',
                width: width, //'100%',
                height: height, //'3.8rem',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                border: 0,
                background:
                  keyIndex == checked
                    ? `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`
                    : `transparent`,
                // ...item.style,
                marginRight: '1rem',
              }}
            >
              <Text
                style={{
                  marginLeft: '0.5rem',
                  width: '80%',
                  color: keyIndex == checked ? '#FFF' : '#4B465C',
                  textAlign: 'start',
                  alignItem: 'center',
                }}
              >{`${item.title}`}</Text>
            </Button>
          );
        })}
    </div>
  );
};

export default TabsMenu;
